export const FETCH_LIMIT_API = '/player/limits/:id/get';
